import { render, staticRenderFns } from "./OrderParentChildren.pug?vue&type=template&id=158ff342&scoped=true&lang=pug&"
import script from "./OrderParentChildren.vue?vue&type=script&lang=js&"
export * from "./OrderParentChildren.vue?vue&type=script&lang=js&"
import style0 from "./OrderParentChildren.scss?vue&type=style&index=0&id=158ff342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ff342",
  null
  
)

export default component.exports